/** DOM ids and navigation steps for admin pump hub PDF export. */
export const ADMIN_PUMP_EXPORT_IDS = {
  accounting: 'admin-pump-accounting-export',
  /** Off-screen DOM used for PDF — full scan findings, not the one-at-a-time navigator. */
  accountingFullAudit: 'admin-pump-accounting-full-audit-export',
  intelligence: 'admin-pump-ops-intelligence-export',
  dataAnalytics: 'admin-pump-data-analytics-export',
  ownerDashboard: 'admin-pump-owner-dashboard-export',
  businessInsights: 'admin-pump-business-insights-export',
  ownerFundAnalytics: 'admin-pump-owner-fund-export',
};

export const PUMP_INSIGHT_CARDS = [
  {
    key: 'accounting',
    title: 'Accounting Check',
    description: 'Scan books, health score, findings, and fix history.',
    tab: 'accounting',
    view: null,
  },
  {
    key: 'intelligence',
    title: 'Operations Intelligence',
    description: 'Nozzle queue, employee tiers, and pairing insights.',
    tab: 'operations',
    view: 'intelligence',
  },
  {
    key: 'data-analytics',
    title: 'Data Analytics',
    description: 'Executive health, deep analysis, cash and stock intelligence.',
    tab: 'operations',
    view: 'data-analytics',
  },
  {
    key: 'owner-dashboard',
    title: 'Owner Dashboard',
    description: 'Sales, profit, fuel mix, stock, expenses, and employee charts.',
    tab: 'operations',
    view: 'owner-dashboard',
  },
  {
    key: 'business-insights',
    title: 'Business Insights',
    description: 'Staffing, profitability, cash irregularities, and diagnostics.',
    tab: 'operations',
    view: 'business-insights',
  },
];
